import { useFeatureToggles } from "@grandvisionhq/state";
const useVirtualAppointment = () => {
  const { featureConfigs } = useFeatureToggles();
  const { appointmentBookingVirtualAppointmentTypeId } = featureConfigs ?? {};
  const isVirtualAppointmentType = (type) => type ? type.id === appointmentBookingVirtualAppointmentTypeId : false;
  return { isVirtualAppointmentType };
};
export {
  useVirtualAppointment as default
};
//# sourceMappingURL=useVirtualAppointment.js.map
